import { useEffect, useRef } from "react";
import axios from "axios";

const API_URL = "/api";
const APP_VERSION = process.env.REACT_APP_VERSION || "dev";

/**
 * Polls /api/version every 5 minutes and notifies user
 * when backend has a different version than the cached frontend.
 * This prevents "stale frontend on new backend" white screens.
 */
export function useVersionCheck(onMismatch) {
  const lastBuildRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const r = await axios.get(`${API_URL}/version`, { timeout: 5000 });
        if (cancelled) return;
        const serverBuild = r.data.build_time;
        if (!lastBuildRef.current) {
          lastBuildRef.current = serverBuild;
        } else if (lastBuildRef.current !== serverBuild) {
          // Backend was redeployed - frontend may be stale
          if (typeof onMismatch === "function") {
            onMismatch({
              client_version: APP_VERSION,
              server_version: r.data.version,
              old_build: lastBuildRef.current,
              new_build: serverBuild
            });
          }
          lastBuildRef.current = serverBuild;
        }
      } catch (e) {
        console.debug("Versionsprüfung fehlgeschlagen:", e);
      }
    };

    // Initial check after 30s, then every 5 minutes
    const initial = setTimeout(check, 30000);
    const interval = setInterval(check, 5 * 60 * 1000);

    return () => {
      cancelled = true;
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, [onMismatch]);
}
